module.exports = __webpack_public_path__ + "adabfe9d1c4034563691e24f7712013d.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/chart.png
// module id = 587
// module chunks = 0